import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/')({
  beforeLoad: () => {
    throw redirect({
      to: '/salary-and-wages-mock/settings/establishments'
    });
  }
});